export default __webpack_public_path__ + "static/assets/med_x_ampoule_1_mask.89e27541.png";